export default __webpack_public_path__ + "static/img-media-meet-38be802c429fdc72e3c13bf84595fb41.jpeg";